
/**
 * User Type Selection Endpoints
 * SUPERADMIN: User Type APIs (list, create, update, delete)
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 * Correct: 'user-type/list'
 * Wrong:   'v1/user-type/list'
 */
export const USERTYPE_ENDPOINTS = {
  // User Type CRUD Operations
  list: 'user-role/list-roles',
  create: 'user-role/create-user-role',
  update: 'user-role/update-role',
  delete: 'user-role/delete-role',
  getById: 'user-role/get-role-by-id',
  
  // User Type Configuration
  getConfig: '/user-role/get-config',
  updateConfig: '/user-role/update-config',
  
// system defined user types (for reference)
  created_user_types: 'users/create-user',
  get_user_types: 'users/get-users',
  disable_user: 'users/toggle-status',
};
